import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, OnInit } from '@angular/core';
import { SliderNpsBaseComponent } from '@player/+survey/question/slider-nps/slider-nps-base.component';
import { SliderImages } from '@player/shared/components/slider-images/slider-images.component';
import { SliderLabel } from '@player/shared/components/slider-label/slider-label.component';
import { SliderThumb } from '@player/shared/components/slider-thumb/slider-thumb.component';
import { SliderLabel as SliderLabelService } from '@player/shared/services/slider-label.service';
import { FadeInOut } from '@shared/animations/fade-in-out.anim';
import { Questions } from '@shared/enums/questions.enum';

@Component({
  selector: 'slider-nps',
  templateUrl: './slider-nps-base.component.html',
  styleUrls: ['../slider-abstract/slider-abstract.component.scss', './slider-nps-base.component.scss'],
  providers: [SliderLabelService],
  animations: [FadeInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AsyncPipe, NgStyle, SliderThumb, SliderLabel, SliderImages],
})
export class SliderNps extends SliderNpsBaseComponent implements OnInit, OnChanges {
  protected readonly questionType: Questions = Questions.SLIDER_NPS;
}
